// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Zc21","large":"styles_large__1QriA"};